export default "__VITE_ASSET__CzwFjRZx__"